import { render, staticRenderFns } from "./ReportDifferenceTextField.vue?vue&type=template&id=818d0cf6&"
import script from "./ReportDifferenceTextField.vue?vue&type=script&lang=js&"
export * from "./ReportDifferenceTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports